<template>
  <div class="content-block">
    <div class="info-title">
      <span>
        企业信息
      </span>
      <el-button type="primary" icon="el-icon-edit" size="small" @click="toUpdateCompanyInfo"
        v-if="userInfo.isAuthed == 'passAuth'">修改</el-button>
    </div>
    <div class="content-layer">
      <div class="area-wrap clearfix">
        <div class="area-title">
          <span class="bar"></span>
          <span>企业</span>
        </div>
        <div class="base-info">
          <div class="base-item clearfix">
            <p class="base-title">企业名称</p>
            <p class="base-content">{{ info.companyName }}</p>
          </div>
          <div class="base-item clearfix">
            <p class="base-title">企业统一社会信用代码</p>
            <p class="base-content">{{ info.companyNo }}</p>
          </div>
          <div class="base-item clearfix">
            <p class="base-title">营业执照</p>
            <div class="base-content" v-show="info.licenseImgBase64">
              <div class="img-container">
                <el-image fit="contain" :src="info.licenseImgBase64" alt="" :preview-src-list="[info.licenseImgBase64]"
                  style="width: 120px"></el-image>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="area-wrap clearfix">
        <div class="area-title">
          <span class="bar"></span>
          <span>法人</span>
        </div>
        <div class="base-info">
          <div class="base-item clearfix">
            <p class="base-title">法定代表人姓名</p>
            <p class="base-content">{{ info.legalName }}</p>
          </div>
          <div class="base-item clearfix">
            <p class="base-title">法定代表人身份证号</p>
            <p class="base-content">{{ info.legalNo }}</p>
          </div>
          <div class="base-item clearfix">
            <p class="base-title">法定代表人联系电话</p>
            <p class="base-content">{{ info.legalPhone }}</p>
          </div>
          <div class="base-item clearfix">
            <p class="base-title">法定代表人身份证人像照</p>
            <div class="base-content" v-show="info.legalFrontImgBase64">
              <div class="img-container">
                <el-image fit="contain" :src="info.legalFrontImgBase64" alt=""
                  :preview-src-list="[info.legalFrontImgBase64]" style="width: 120px"></el-image>
              </div>
            </div>
          </div>
          <div class="base-item clearfix">
            <p class="base-title">法定代表人身份证国徽照</p>
            <div class="base-content" v-show="info.legalBackImgBase64">
              <div class="img-container">
                <el-image fit="contain" :src="info.legalBackImgBase64" alt=""
                  :preview-src-list="[info.legalBackImgBase64]" style="width: 120px"></el-image>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="area-wrap clearfix">
        <div class="area-title">
          <span class="bar"></span>
          <span>管理员</span>
        </div>
        <div class="base-info">
          <div class="base-item clearfix">
            <p class="base-title">管理员姓名</p>
            <p class="base-content">{{ info.agentName }}</p>
          </div>
          <div class="base-item clearfix">
            <p class="base-title">管理员身份证号</p>
            <p class="base-content">{{ info.agentNo }}</p>
          </div>
          <div class="base-item clearfix">
            <p class="base-title">管理员身份证人像照</p>
            <div class="base-content" v-show="info.agentFrontImgBase64">
              <div class="img-container">
                <el-image fit="contain" :src="info.agentFrontImgBase64" alt=""
                  :preview-src-list="[info.agentFrontImgBase64]" style="width: 120px"></el-image>
              </div>
            </div>
          </div>
          <div class="base-item clearfix">
            <p class="base-title">管理员身份证国徽照</p>
            <div class="base-content" v-show="info.agentBackImgBase64">
              <div class="img-container">
                <el-image fit="contain" :src="info.agentBackImgBase64" alt=""
                  :preview-src-list="[info.agentBackImgBase64]" style="width: 120px"></el-image>
              </div>
            </div>
          </div>
          <div class="base-item clearfix">
            <p class="base-title">法人授权书</p>
            <div class="base-content" v-show="info.authFileImgBase64">
              <div class="img-container">
                <el-image fit="contain" :src="info.authFileImgBase64" alt="" :preview-src-list="[info.authFileImgBase64]"
                  style="width: 120px"></el-image>
              </div>
            </div>
          </div>
        </div>
      </div>




    </div>

  </div>
</template>
<script>
import { getComapnayAuthInfo } from "@/api/auth/auth";
import { mapState } from "vuex";

export default {
  components: {
  },
  data() {
    return {
      info: {}
    };
  },
  created() {
    this.getInfoHandle();
  },
  mounted() {
  },
  methods: {
    getInfoHandle() {
      getComapnayAuthInfo({ userId: this.userInfo.userId }).then(res => {
        res.data.legalNo = this.formatIdCardNo(res.data.legalNo);
        res.data.agentNo = this.formatIdCardNo(res.data.agentNo);
        this.info = res.data;
      })
    },
    formatIdCardNo(num) {
      return num ? num.replace(
        /(\w{6})(\w+)(\w{5})/,
        function (x, y, z, p) {
          var i = "";
          while (i.length < z.length) {
            i += "*";
          }
          return y + i + p;
        }
      ) : ""
    },
    toUpdateCompanyInfo() {
      this.$router.push("/company-auth-info?edit=yes")
    }
  },
  computed: {
    ...mapState(["userInfo", "userContractInfo", "companyList"]),
  },
};
</script>
<style>
#user-info-layer .base-input input {
  height: 36px;
}
</style>
<style scoped>
.base-info {
  margin-top: 20px;
  margin-left: 20px;
}

.base-item {
  position: relative;
  line-height: 27px;
  font-size: 14px;
  margin-top: 20px;
}

.base-title {
  float: left;
  width: 190px;
  font-weight: 400;
  color: #4E5969;
}

.base-content {
  float: left;
  margin-left: 50px;
  font-weight: 400;
  color: #1D2129;

}

.base-input {
  position: absolute;
  left: 150px;
  top: 0;
  width: 150px;
  height: 36px;
}

.base-edit {
  /* width: 67px;
  height: 26px; */
  position: absolute;
  left: 350px;
  top: 0px;
  /* background: #3296FA;
  border-radius: 10px;
  display: block;
  color: white;
  font-size: 13px;
  text-align: center;
  line-height: 26px;
  padding: 0; */
}

.add-item {
  position: absolute;
  left: 520px;
  top: 0;
  color: #1b96ff;
}

.person-info {
  margin: 36px 0 0 46px;
}

.company-info {
  /* width: 942px; */
  margin-top: 20px;
}

.company-list {
  width: 100%;
  height: 54px;
  overflow-x: auto;
  overflow-y: hidden;
}

.company-list a {
  display: block;
  width: 175px;
  height: 43px;
  text-align: center;
  overflow: hidden;
  font-size: 16px;
  color: #333333;
  background: #e5e5e5;
  line-height: 43px;
  float: left;
  margin-right: 17px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.company-list a:last-child {
  margin-right: 0;
}

.company-list a.active {
  background: #ffffff;
}

.company-content {
  /* width: 942px; */
  min-height: calc(100vh - 587px);
  background: rgba(255, 255, 255, 1);
  overflow: hidden;
}

.company-name {
  font-size: 16px;
  color: #333333;
  width: 855px;
  margin: 27px auto 0;
  padding-bottom: 17px;
  border-bottom: 1px solid #e4e4e4;
  line-height: 18px;
}

.company-box {
  margin: 15px 0 0 43px;
}

.company-box .base-title {
  width: 112px;
}

.company-box .base-content {
  margin-left: 43px;
  margin-right: 20px;
}

.company-box .add-item {
  left: 433px;
}

.clearfix {
  clear: both;
}

.run-layer {
  padding-left: 42px;
  padding-top: 30px;
  margin-bottom: 20px;
}
</style>
<style lang="scss" scoped>
.content-block {
  position: relative;
  height: 100%;
}

.info-title {
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  font-weight: 500;
  color: #1D2129;
  border-bottom: 1px solid #F2F3F5;
  padding-left: 22px;
  padding-right: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.content-layer {
  height: calc(100% - 60px);
  overflow: auto;
  padding: 0 20px 0;
}
</style>

<style lang="scss" scoped>
.area-wrap {

  border-bottom: 1px solid #F2F3F5;
  padding-top: 20px;
  padding-bottom: 20px;

  .area-title {
    display: flex;
    align-items: center;
    font-size: 14px;

    .bar {
      display: block;
      width: 3px;
      height: 12px;
      background: #165DFF;
      margin-right: 8px;
    }
  }

}

.img-container {
  width: 120px;
  height: 76px;
  background: rgba(245, 246, 252, 0.56);
  border-radius: 6px 6px 6px 6px;
  border: 1px solid #D8D8D8;
  display: flex;
  align-items: center;

  .el-image {
    width: 100%;
    height: 85%;
  }
}
</style>